//CodedValueDomains.ts ==============================================================
import "../Util/Prototypes";

import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";

import Axios, { AxiosResponse } from "axios";

export interface iCodedValueSpec {
   layerName: string;
   sublayerNames: string[];
   sublayerIndexes?: number[];
}

let mapImageURLs: string[];
let ii: number;

//Get coded value domains for map image services.
export function getMapImageCodedValueDomains(): void {
   Util.logMsg("Util_App.getMapImageCodedValueDomains");
   mapImageURLs = [];

   for (const codedValueSpec of Settings.codedValueSpecs) {
      const layer = Util_App.getOperationalLayerById(codedValueSpec.layerName) as __esri.MapImageLayer;
      if (layer && codedValueSpec.sublayerIndexes) {
         for (const sublayerIndex of codedValueSpec.sublayerIndexes) {
            if (sublayerIndex !== -1) {

               let url: string = layer.url + "/" + sublayerIndex + "?f=pjson";
               if (layer.id === "") { // For secure layers. Custom!
                  url = Settings.proxyUrl + "?" + url;
               }

               mapImageURLs.Add(url);
            }
         }
      }
   }

   ii = -1;
   getCodedValues();
}

//Get coded values with REST ajax requests.
function getCodedValues() {
   ii++; //Process next map image service.

   if (ii < mapImageURLs.length) {
      const url: string = mapImageURLs[ii];

      Axios.get(url)
         .then(function (response: AxiosResponse<any, any>) {

            if (response.data.error) {
               Util.errMsg("axios.get error getting map image service coded value domains", response.data.error);

            } else {
               if (response.data.fields) {

                  for (const field of response.data.fields) {
                     if (field.domain && field.domain.codedValues && field.domain.codedValues.length > 0) {

                        if (typeof field.domain.codedValues[0].code === "number") {
                           const codedValue: Settings.iCodedValue = { layerName: response.data.name, fieldName: field.name, values: [] };

                           for (const value of field.domain.codedValues) {
                              codedValue.values.Add({ code: value.code, name: value.name });
                           }
                           Settings.codedValues.Add(codedValue);
                        }
                     }
                  }
               }
            }

            getCodedValues();
         })
         .catch(function (error: Error) {
            Util.errMsg("axios.get error getting coded value domains for url: " + url, error);
            getCodedValues();
         });

   } else {
      Util.logMsg("Done getting coded value domains");
   }
}
